import React, { useContext } from 'react';
import FilterControl from '../../FilterControl';
import { ViewFilterName } from '../../../../../enum/types/ViewFilterName';
import { useFormContext } from 'react-hook-form';
import FilerControlChildren from '../../FilerControlChildren';
import { FilterSectionsFormContext } from '../../../context/FilterSectionsFormContext';

const CompanyTagControls: React.FC = () => {
  const { dictionaries } = useContext(FilterSectionsFormContext);
  const formContext = useFormContext();
  const { watch } = formContext;

  const selectedTags = watch(ViewFilterName.CompanyTags) ?? [];
  const selectedTagIds = selectedTags.map((id: string) => parseInt(id, 10)).filter(Number.isInteger);

  const aiTagIds = dictionaries?.AiTagIds?.map(item => item.id) ?? [];

  const hasAiUsage = selectedTagIds.some((id: number) => aiTagIds.includes(id));

  return (
    <>
      <FilterControl
        name={ViewFilterName.CompanyTags}
        controlProps={{
          options: dictionaries?.[ViewFilterName.CompanyTags],
        }}
      />

      <FilerControlChildren hasChildren={hasAiUsage}>
        <FilterControl
          name={ViewFilterName.AiUsage}
          controlProps={{
            options: dictionaries?.[ViewFilterName.AiUsage],
          }}
        />
      </FilerControlChildren>
    </>
  );
};

export default CompanyTagControls;
